


import { Component, Vue } from 'vue-property-decorator';
import ConfContainer from '../../components/ConfContainer/index.vue';
import PageTransitionMode from '@/utils/mixins/pageTransitionMode';
import { namespace } from 'vuex-class';
import { Floor, Zone } from '../../utils/api';
import { RenderMode } from '../../components/ConfContainer/ConfContainer.models';
import { SelectType } from '../../components/SelectionPanel/SelectionPanel.models';
import { Route } from 'vue-router';

const upperFloorModule = namespace('upperFloor');
const configurationModule = namespace('configuration');

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    ConfContainer
  },
  mixins: [PageTransitionMode]
})
export default class UpperFloor extends Vue {
  @upperFloorModule.State private completedZoneIDs!: string[];

  @upperFloorModule.Getter private floor!: Floor;
  @upperFloorModule.Getter private activeZone!: Zone;
  @upperFloorModule.Getter private activeSubzone!: Zone;

  @upperFloorModule.Action private showLayout!: () => void;
  @upperFloorModule.Action private updateActiveZone!: (zoneID: string) => void;
  @upperFloorModule.Action private updateActiveSubzone!: (zoneID: string) => void;
  @upperFloorModule.Action private addCompletedZone!: (zoneID: string) => void;
  @configurationModule.Action private setVisitedZones!: (zoneID: string) => void;

  // to make ts enums work in vue template
  private SelectType: typeof SelectType = SelectType;
  private RenderMode: typeof RenderMode = RenderMode;

  public beforeRouteLeave(_to: Route, _from: Route, next: () => void) {
    if (this.activeZone) {
      this.addCompletedZone(this.activeZone.ID);
    }

    if (this.completedZoneIDs.length === this.floor.zones.length) {
      this.$store.dispatch('app/completeStep', this.$route.name || '');
    }

    next();
  }

  private created() {
    if (this.activeZone?.zones && !this.activeSubzone) this.updateActiveSubzone(this.activeZone.zones[0].ID);
  }

  private changeZone(zoneID: string) {
    this.setVisitedZones(zoneID);
    this.updateActiveZone(zoneID);

    if (this.activeZone.zones?.length) {
      this.setVisitedZones(this.activeZone.zones[0].ID);
    }
  }

  private changeSubzone(zoneID: string) {
    this.setVisitedZones(zoneID);
    this.updateActiveSubzone(zoneID);
  }

  private beforeDestroy() {
    if (this.activeZone) {
      this.addCompletedZone(this.activeZone.ID);
    }
  }
}
